import React, {FunctionComponent, useEffect} from "react";
import {observer} from "mobx-react";
import {IconButton} from "@mui/material";
import {useStorageTranslateContext} from "@app/modules/Translate/contexts/storage";
import {useModelContext} from "@app/contexts/model";
import {TFlatJsonStruct} from "@app/factory/flatJson";
import {setRowVisible} from "@app/modules/Translate/factory/setRowVisible";
import './ButtonFunctions.scss'
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


interface INextWordProps {
}


export const NextWord: FunctionComponent<INextWordProps> = observer<FunctionComponent<INextWordProps>>(function (props) {

    const {translateStore} = useStorageTranslateContext();
    const {languageFileModel} = useModelContext();

    let dataLanguageResponse = languageFileModel.dataLanguage.get();

    let disabled = !dataLanguageResponse;

    function onClick() {
        let gridId: string = null;
        let length = 0;
        translateStore.gridApi.forEachNodeAfterFilter(rowNode => {
            length++;
                if (gridId === null && (rowNode.data as TFlatJsonStruct).translate === "") {
                    gridId = rowNode.id; // kategoria z pustym tlumaczeniem
                    if (translateStore.filteredSet.has(gridId)) {
                        gridId = null
                    }
                }
            }
        );

        if (gridId !== null) {
            translateStore.nextWordsKey = gridId; // kategoria z pustym tlumaczeniem, wrzucamy do stora z nextWordsKey
            setRowVisible(translateStore.gridApi, translateStore.nextWordsKey);
            const node = translateStore.gridApi.getRowNode(gridId);
            let rowIndex = node.rowIndex;  // numer wiersza, linijki
            translateStore.gridApi.setFocusedCell(rowIndex, "translate")
            translateStore.gridApi.redrawRows({
                rowNodes:[node]
            });
            translateStore.filteredSet.add(gridId)
            setTimeout(()=>translateStore.gridApi.startEditingCell({
                rowIndex: rowIndex,
                colKey: "translate",
            }),100);
        } else {
            translateStore.filteredSet.clear();
            length && onClick()
        }
    }


    function doc_keyUp(e: KeyboardEvent) {
        if (e.ctrlKey && e.altKey && e.code === "KeyF") {
            onClick();
        }
    }

    useEffect(() => {
        document.addEventListener('keyup', doc_keyUp, false);
        return () => {
            document.removeEventListener('keyup', doc_keyUp);
        }
    });

    return <IconButton
        disabled={disabled}
        className={"featureButtons__i"}
        aria-hidden="true"
        title="Go to next untranslated word Ctrl+Alt+F"
        onClick={() => {
            onClick()
        }}
    >
        <FontAwesomeIcon icon={faSearch}/>
    </IconButton>
});

